












import Vue from 'vue';
import { PaymentMethod, List } from '../types';
import CustomerContextMixin from '../customer/CustomerContextMixin';
import AddPaymentMethodBtn from './AddPaymentMethodBtn.vue';
import PaymentMethodList from './PaymentMethodList.vue';

export default Vue.extend({
  components: { AddPaymentMethodBtn, PaymentMethodList },
  mixins: [CustomerContextMixin],
  methods: {
    add(paymentMethod: PaymentMethod) {
      (this.$refs.paymentMethods as List).add(paymentMethod);
    },
  },
});
